// Auto-generated from translation.csv; do not edit manually
export const esES = {
  "accountGuide": {
    "content": "Abre cualquier juego de Touka, ve a la pantalla principal del juego para vincular tu correo electrónico y, una vez vinculado, disfruta de descuentos especiales en productos.",
    "title": "¿Cómo crear una cuenta?"
  },
  "bottomNav": {
    "home": "Inicio",
    "myOrders": "Mis pedidos"
  },
  "common": {
    "loading": "Cargando...",
    "noData": "Sin datos",
    "server": "Servidor"
  },
  "auth": {
    "tokenExpired": "Inicio de sesión caducado"
  },
  "errors": {
    "900400": "Error de parámetro interno",
    "900401": "Autenticación fallida",
    "900402": "Inicio de sesión caducado",
    "1000000": "Error del sistema. Inténtalo de nuevo más tarde",
    "1000001": "Error de parámetro del sistema. Inténtalo de nuevo más tarde",
    "1000002": "El ID o código captcha no puede estar vacío",
    "1000003": "Correo electrónico no válido",
    "1000004": "Código captcha no válido",
    "1000005": "El código de correo ya se ha enviado. Espera 1 minuto e inténtalo de nuevo",
    "1000006": "Se alcanzó el límite de envío de códigos. Inténtalo mañana",
    "1000007": "El correo electrónico no puede estar vacío",
    "1000008": "El código no puede estar vacío",
    "1000009": "Código no válido",
    "1000010": "Error al obtener el token de inicio de sesión",
    "1000011": "El producto está inactivo. Selecciona otro producto",
    "1000012": "El producto ha superado el límite de compra. Selecciona otro producto",
    "1000013": "El producto ha sido retirado",
    "1000014": "Método de pago no habilitado",
    "1000015": "Tu cuenta no permite comprar productos. Contacta con atención al cliente",
    "1000016": "No se pudo crear el pedido. Inténtalo de nuevo",
    "1000017": "Este pedido no se puede cancelar",
    "1000018": "Se alcanzó el límite de cantidad para una sola compra",
    "1000019": "El código de verificación ha caducado. Solicita uno nuevo"
  },
  "footer": {
    "language": "Chino (Simplificado)",
    "privacyPolicy": "Política de privacidad",
    "refundPolicy": "Política de reembolso",
    "termsOfService": "Términos de servicio",
    "userSupport": "Soporte al usuario",
    "downloadNow": "¡Descargar ahora!"
  },
  "header": {
    "characterName": "Nombre del personaje",
    "gameServer": "Región del juego",
    "selectGameServer": "Seleccionar región del juego",
    "greeting": "Hola",
    "loginPrompt": "Por favor, haz clic para iniciar sesión",
    "switchServer": "Cambiar",
    "title": "Centro de recarga del juego",
    "logout": "Cerrar sesión"
  },
  "games": {
    "bamBamSquad": "BamBamSquad",
    "oopsieCroco": "Oopsie Croco"
  },
  "history": {
    "backToGameZone": "Volver a la tienda del juego",
    "allGames": "Todos los juegos",
    "empty": "Sin pedidos",
    "filter": {
      "all": "Todos",
      "closed": "Cerrado",
      "completed": "Completado",
      "inProgress": "En progreso",
      "pendingDelivery": "Pendiente de envío"
    },
    "orderTime": "Hora del pedido:",
    "pendingAutoCancelPrefix": "El pedido se cancelará en",
    "pendingAutoCancelSuffix": "automáticamente",
    "cancelOrder": "Cancelar pedido",
    "payOrder": "Pagar",
    "cancelOrderConfirmTitle": "¿Cancelar pedido?",
    "cancelOrderConfirmPrimary": "Confirmar",
    "cancelOrderDismiss": "Ahora no",
    "cancelOrderSuccess": "Pedido cancelado",
    "previousPage": "Anterior",
    "nextPage": "Siguiente",
    "status": {
      "cancelled": "Cerrado",
      "completed": "Transacción completada",
      "paid": "Pagado",
      "pending": "Pendiente de pago",
      "refunded": "Reembolsado",
      "shipped": "Enviado"
    }
  },
  "home": {
    "selectGame": "Seleccione el juego para recargar",
    "selectGameMobileTitle": "Elegir juego para recargar",
    "mobileGameCardGo": "Ir",
    "selectGameParts": {
      "prefix": "Seleccione el juego para ",
      "keyword": "recargar",
      "suffix": ""
    },
    "purchaseEntryParts": {
      "prefix": "Ir a ",
      "keyword": "comprar",
      "suffix": ""
    },
    "noRoleAccount": "Aún no tienes un personaje en este juego. Crea uno en el juego antes de comprar.",
    "noRoleRefreshPrefix": "¿Ya creaste una cuenta? Pulsa ",
    "noRoleRefreshAction": "Actualizar",
    "noRoleRefreshing": "Actualizando…",
    "noRoleRefreshNotFound": "No se encontró información del personaje",
    "noRoleRefreshFailed": "Error al actualizar. Inténtalo de nuevo más tarde."
  },
  "login": {
    "agreeTerms": {
      "and": "y",
      "prefix": "He leído y acepto",
      "privacy": "Política de privacidad",
      "terms": "Términos de servicio"
    },
    "cancel": "Cancelar",
    "bindGameGuide": "Aviso de vinculación del juego",
    "bindGameGuideContent": "Abre cualquier juego Touka,\nve a Ajustes dentro del juego,\nvincula tu correo\ny disfruta de ofertas especiales en la tienda.",
    "captchaPlaceholder": "Código de verificación",
    "invalidCaptcha": "Por favor, ingrese un código de verificación de 4 dígitos",
    "email": "Correo electrónico",
    "emailNotBound": "No pudimos encontrar la cuenta. Ingresa el correo vinculado a tu cuenta del juego~",
    "emailPlaceholder": "Por favor ingrese su correo electrónico",
    "keepLogin": "Mantener sesión iniciada por 15 días",
    "loading": "Iniciando sesión...",
    "loginToStore": "Iniciar sesión en Touka Store",
    "noAccount": "¿No tienes cuenta?",
    "password": "Contraseña",
    "passwordPlaceholder": "Por favor ingrese la contraseña",
    "submit": "Iniciar sesión",
    "title": "Iniciar sesión",
    "invalidEmail": "Introduce una dirección de correo válida"
  },
  "logout": {
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "dontRemind": "No volver a recordar la próxima vez",
    "messageLine1": "Después de cerrar sesión, el estado de inicio de sesión en todos los dispositivos usados en los últimos 30 días",
    "messageLine2": "se invalidará.",
    "title": "Aviso"
  },
  "menu": {
    "contactSupport": "Contactar servicio al cliente",
    "gameList": "Lista de juegos",
    "myOrders": "Mis pedidos"
  },
  "paymentSuccess": {
    "account": "Cuenta:",
    "celebrationTitle": "Compra exitosa",
    "confirm": "Confirmar",
    "getPaymentInfoFailed": "Error al obtener información de pago",
    "loading": "Cargando...",
    "orderDate": "Fecha del pedido:",
    "orderId": "Número de pedido:",
    "paymentMethod": "Método de pago:",
    "paypal": "PayPal",
    "price": "Precio:",
    "purchaseContent": "Contenido de la compra:",
    "quantity": "Cantidad comprada:",
    "serverAndCharacter": "Servidor/Personaje:",
    "title": "Gracias por su compra",
    "total": "Total:",
    "unionPay": "UnionPay",
    "amountPaid": "Importe pagado:",
    "closeModal": "Cerrar"
  },
  "productModal": {
    "confirm": "Confirmar",
    "purchaseDetails": "Detalles de la compra",
    "quantity": "Cantidad:",
    "total": "Total:",
    "unitPrice": "Precio unitario:"
  },
  "products": {
    "giftPacks": "Paquete de regalo",
    "diamond": "Diamante",
    "products": "Producto",
    "vouchers": "Superdiamantes",
    "toukaCoin": "Superdiamantes",
    "toukaCoinBonusTip": "¡Compra en TOUKA Store y disfruta de un 10 % extra de recompensa!",
    "superValue": "Gran valor",
    "limitShort": "Límite",
    "remainingShort": "Tiempo rest.",
    "giftPackLimitType": {
      "lifetime": "Oferta vitalicia",
      "weekly": "Oferta semanal",
      "monthly": "Oferta mensual"
    },
    "howToUseVouchers": "¿Cómo usar Superdiamantes?",
    "voucherGuide": {
      "title": "¿Cómo usar Superdiamantes?",
      "step1": "1. Revisa el buzón del juego para recibir los Superdiamantes que compraste.",
      "step2": "2. Puedes consultar tu saldo de Superdiamantes en la parte superior de la pestaña de la tienda del juego. Cuando tengas suficientes Superdiamantes para comprar un paquete de regalo, se usarán primero para la compra.",
      "backToProducts": "Volver a la lista de productos"
    },
    "luxuryVouchers": "Superdiamantes"
  },
  "purchaseConfirm": {
    "card": "Tarjeta de crédito/débito",
    "confirm": "Confirmar",
    "dontAskAgain": "No preguntar dentro de 30 días",
    "gameServer": "Servidor del juego",
    "paymentMethods": "Métodos de pago compatibles",
    "paypal": "PayPal",
    "title": "¿Seguro que deseas realizar esta compra con esta cuenta?",
    "unionPay": "Tarjeta UnionPay"
  },
  "serverSelect": {
    "characterLabel": "Nombre del personaje",
    "characterPlaceholder": "Por favor seleccione un personaje",
    "confirm": "Confirmar",
    "noResults": "Sin resultados",
    "serverPlaceholder": "Por favor ingrese el nombre del servidor para buscar",
    "title": "Seleccionar servidor del juego"
  },
  "orientation": {
    "bestExperience": "Cambia al modo vertical para obtener la mejor experiencia"
  },
  "support": {
    "cancel": "Cancelar",
    "copied": "Copiado",
    "copy": "Copiar con un clic",
    "description": "Por favor, envía tu información detallada al correo oficial de soporte.",
    "title": "Soporte al cliente"
  },
  "verification": {
    "back": "Volver",
    "enterCode": "Por favor ingrese el código de verificación para continuar",
    "incorrectCode": "Código de verificación incorrecto",
    "invalidCode": "Por favor ingrese un código de verificación de 6 dígitos",
    "noCode": "¿No recibe el código de verificación?",
    "sentTo": "El código de verificación ha sido enviado a",
    "submit": "Enviar",
    "submitting": "Enviando..."
  }
} as const;
